<!--
  @Description: 购票
  @Author: wang.y 
  @Date: 2024-07-27 
-->
<template>
  <div class="main-container">
    <page-header>{{'预注册' | dealLanguage('Pre-registration')}}</page-header>
    <div class="center-wrapper">
      <TopTip></TopTip>
      <div class="form-view">
        <Form ref="current-form" :model="currentForm" :rules="ruleValidate2">
          <div class="view-title">
            <div class="title">{{'个人信息' | dealLanguage('Personal Information')}}</div>
            <div class="line"></div>
          </div>
          <FormItem prop="name" :label="'姓名' | dealLanguage('Name')">
            <Input type="text" v-model="currentForm.name" :placeholder="'请填写姓名' | dealLanguage('Please fill in your name')"></Input>
          </FormItem>
          <Row :gutter="26" v-if="language == 'zh'">
            <Col span="6">
            <FormItem prop="mobileAreaCode" :label="'国家地区码' | dealLanguage('Area Code')">
              <Select v-model="currentForm.mobileAreaCode" :placeholder="'请选择国家/地区码' | dealLanguage('Please select a country/region code')">
                <Option v-for="item in appMobileAreaCodeDtos" :value="item.mobileAreaCode" :key="item.mobileAreaCode">+{{item.mobileAreaCode}} ({{item.countryName | dealLanguage(item.countryEnName)}})</Option>
              </Select>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem prop="mobile" label="手机号码">
              <Input type="text" class="right-padding" :disabled="isVerifyCode" v-model="currentForm.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
              <Captcha ref="captcha" scene="vbdata_loginon" :mobile="currentForm.mobile" :mobileAreaCode="currentForm.mobileAreaCode" v-if="!isVerifyCode" captchaButtonId="sign-captcha-button" captchaElementId="sign-captcha-element"></Captcha>
              <Button type="text" class="code-btn" v-else @click="handleUpdateMobile">更新手机号</Button>
            </FormItem>
            </Col>
            <Col span="6">
            <FormItem prop="verifyCode" label="验证码">
              <Input type="text" v-model="currentForm.verifyCode" :disabled="isVerifyCode" placeholder="请填写验证码"></Input>
              <div class="verify-success" v-if="isVerifyCode">
                <i class="iconfont">&#xe71d;</i>
                <span>验证成功</span>
              </div>
            </FormItem>
            </Col>
          </Row>
          <FormItem prop="email" v-if="language == 'zh'" label="E-mail">
            <Input type="text" v-model="currentForm.email" placeholder="请填写邮箱"></Input>
          </FormItem>
          <Row :gutter="26" v-else>
            <Col span="12">
            <FormItem prop="email" label="E-mail">
              <Input type="text" class="right-padding" :disabled="isVerifyCode" v-model="currentForm.email" placeholder="Please fill in your email"></Input>
              <Captcha ref="captcha" validMode="2" scene="vbdata_loginon" :email="currentForm.email" v-if="!isVerifyCode" captchaButtonId="sign-email-captcha-button" captchaElementId="sign-email-captcha-element"></Captcha>
              <Button type="text" class="code-btn" v-else @click="handleUpdateMobile">Update E-mail</Button>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem prop="verifyCode" label="E-mail Verification Code">
              <Input type="text" v-model="currentForm.verifyCode" :disabled="isVerifyCode" placeholder="Please enter the verification code"></Input>
              <div class="verify-success" v-if="isVerifyCode">
                <i class="iconfont">&#xe71d;</i>
                <span>Verification successful</span>
              </div>
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="26">
            <Col span="12">
            <FormItem prop="compName" :label="'公司' | dealLanguage('Company Name')">
              <div class="input-tag">
                <AutoComplete v-model="entityKeyword" :placeholder="!currentForm.entityId ? filter.dealLanguage('请搜索并选择公司', 'Please search and select a company') : ''" @on-search="handleSearchEntity" @on-select="handleSelectEntity" @on-change="handleChangeEntity">
                  <Option v-for="item in entityList" :value="item.id" :key="item.id">
                    <div class="title">
                      {{item.shortName}}
                    </div>
                    <div class="desc">
                      {{item.description}}
                    </div>
                  </Option>
                </AutoComplete>
                <div class="tag-div" v-if="currentForm.entityId">
                  <Tag closable @on-close="handleClose" color="blue">{{currentForm.compName}}</Tag>
                </div>
              </div>
            </FormItem>
            <!-- <FormItem prop="department" :label="'部门' | dealLanguage('Department')">
              <Input type="text" v-model="currentForm.department" :placeholder="'请填写部门' | dealLanguage('Please fill in the department')"></Input>
            </FormItem> -->
            </Col>
            <Col span="12">
            <FormItem prop="title" :label="'职位' | dealLanguage('Position')">
              <Input type="text" v-model="currentForm.title" :placeholder="'请填写职位' | dealLanguage('Please fill in the position')"></Input>
            </FormItem>
            </Col>
          </Row>
          <FormItem prop="addressId" :label="'地区' | dealLanguage('Country&City')">
            <Cascader v-model="currentAddressDto" :placeholder="'请选择所在地区' | dealLanguage('Please Select')" :data="addressDtos" change-on-select @on-change="handleChangeAddress"></Cascader>
            <div class="hid-div"><Input type="text" v-model="currentForm.addressId"></Input></div>
          </FormItem>
          <FormItem prop="companyProfile" :label="'公司性质' | dealLanguage('Company Profile')">
            <RadioGroup v-model="currentForm.companyProfile" @on-change="handleChangeCompanyProfile">
              <Radio :label="item" v-for="item,index in companyProfileList" :key="index"></Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="companyprofileother" v-if="companyprofileother">
            <Input type="text" v-model="currentForm.companyprofileother" :placeholder="'其他，请填写' | dealLanguage('Others, please specify')"></Input>
          </FormItem>

          <div class="view-title">
            <div class="title">{{'参会信息' | dealLanguage('Meeting Registration')}}</div>
            <div class="line"></div>
          </div>
          <FormItem prop="concurrent2" :label="'您需要参加哪些论坛？（多选）' | dealLanguage('Forum Selection (Multiple Choices Available)')">
            <CheckboxGroup v-model="currentForm.concurrent2">
              <!-- <p style="font-weight: 600">{{'9月12日下午' | dealLanguage('On the afternoon of September 12th')}}</p>
              <Checkbox :label="item" v-for="item,index in concurrentList.slice(0, 5)" :key="index"></Checkbox>
              <p style="font-weight: 600">{{'9月13日上午' | dealLanguage('On the morning of September 13th')}}</p>
              <Checkbox :label="item" v-for="item,index in concurrentList.slice(5, 12)" :key="index"></Checkbox>
              <p style="font-weight: 600">{{'9月13日下午' | dealLanguage('On the afternoon of September 13th')}}</p> -->
              <Checkbox :label="item" v-for="item,index in concurrentList[language]" :key="index"></Checkbox>
            </CheckboxGroup>
          </FormItem>
          <div class="view-title">
            <div class="title">{{'请选择门票类型' | dealLanguage('Please select the ticket type')}}</div>
            <div class="line"></div>
          </div>
          <FormItem prop="activityTicketId">
            <div class="ticket-list">
              <RadioGroup v-model="currentForm.activityTicketId" @on-change="handleSeletTicket">
                <Radio :label="item.id" v-for="item,index in ticketList" :key="index">
                  <div class="ticket-item ticket-container">
                    <div class="ticket-item-top">
                      <div class="ticket-item-top-left">
                        <img :src="item.activityShareImagePath | logo_show" />
                      </div>
                      <div class="ticket-item-top-right">
                        <div class="title">{{item.title | dealLanguage(item.enTitle)}}</div>
                        <div class="desc" v-html="item.remark" v-if="item.remark && language == 'zh'"></div>
                        <div class="desc" v-html="item.enRemark" v-if="item.enRemark && language == 'en'"></div>
                      </div>
                    </div>
                    <div class="price-container" v-if="item.price">
                      <div class="lt">
                        <template v-if="channelDiscountRate < 1">
                          <span class="discount" v-if="language == 'en'">{{channelDiscountRate | discountShow}}</span>
                          <span class="discount" v-if="language == 'zh'">{{channelDiscountRate | discountShowZh}}</span>
                        </template>
                      </div>
                      <div class="rt">
                        <span class="price">{{'￥' | dealLanguage('$')}}{{ item.price | ticketPrice }}</span>
                        <span class="original-price" v-if="channelDiscountRate < 1">${{ item.price }}</span>
                        <span class="original-price" v-if="item.originalPrice && channelDiscountRate === 1">${{ item.originalPrice }}</span>
                      </div>
                    </div>
                    <div class="price-container" v-else>
                      <div class="lt"></div>
                      <div class="rt">
                        <span class="price" v-if="[154, 162].includes(item.id)">{{'工作人员会联系您缴费' | dealLanguage('The staff will contact you to make the payment.')}}</span>
                        <span class="price" v-else>{{'免费' | dealLanguage('FREE')}}</span>
                      </div>
                    </div>
                  </div>
                </Radio>
              </RadioGroup>
            </div>
          </FormItem>
        </Form>
        <div class="view-title" v-if="currentTicket.id">
          <div class="title">{{'支付信息' | dealLanguage('Payment information')}}</div>
          <div class="line"></div>
        </div>
        <div class="pay-info" v-if="currentTicket.id">
          <div class="info">
            <div class="info-p1">
              <template v-if="currentTicket.price">
                <span>{{'门票价格：' | dealLanguage('Ticket price: ')}}</span>
                <span>{{'￥' | dealLanguage('$')}}{{currentTicket.price | ticketPrice}}</span>
              </template>
              <template v-else>
                <span v-if="[154, 162].includes(currentTicket.id)">{{'工作人员会联系您缴费' | dealLanguage('The staff will contact you to make the payment.')}}</span>
                <span v-else>{{'免费' | dealLanguage('FREE')}}</span>
              </template>
            </div>
            <div class="info-p2" v-if="currentTicket.price">{{'您需支付' | dealLanguage('You need to pay ')}}{{'￥' | dealLanguage('$')}}{{currentTicket.price | ticketPrice}}{{'用以支付当前门票' | dealLanguage(' for the current ticket.')}}</div>
            <div class="info-p2" v-else>{{'无需支付' | dealLanguage('No need to pay')}}</div>
          </div>
          <div class="btns">
            <div :class="['btn', buttonLoading && 'loading']" @click="submit" :loading="buttonLoading" v-if="language == 'zh'">
              <template v-if="!buttonLoading">
                <div class="btn-left" v-if="currentTicket.price">
                  <img :src="static_img_url + 'pic/wechat-icon.png?v=' + $store.state.imgVersion" />
                  <span>微信支付</span>
                </div>
                <span v-else>获取门票</span>
              </template>
              <span v-else>Loading</span>
              <Icon type="ios-arrow-forward" />
            </div>
            <div :class="['btn', buttonLoading && 'loading']" @click="submitEn" :loading="buttonLoading" v-if="language != 'zh' && !currentTicket.price">
              <span v-if="!buttonLoading">Get ticket now</span>
              <span v-else>Loading</span>
              <Icon type="ios-arrow-forward" />
            </div>
          </div>
        </div>
        <div class="payment-options" v-if="language != 'zh'" v-show="currentTicket.price">
          <div :class="['payment-option', paymentWay == 1 && 'selected']">
            <div class="payment-option__header" @click="handleSelectPaymentOption(1)">
              <div class="payment-option__left">
                <div class="payment-option__radio"></div>
                <span class="payment-option__label">Credit/Debit Card</span>
              </div>
              <div class="payment-option__icons">
                <div v-for="item,index in Array(2)" :key="index">
                  <img :src="static_img_url + `pic/pay/icon${index+1}.png`" />
                </div>
              </div>
            </div>
            <div class="payment-option__container" v-show="paymentWay == 1">
              <div class="payment-option__title">
                <h4>Card Details</h4>
                <p>Not available for credit cards issued in Chinese Mainland</p>
              </div>
              <CardPay ref="card-pay" @updateLoading="updateLoading" />
              <Button type="primary" :loading="buttonLoading" @click="submitEn">
                <span v-if="buttonLoading">Generating Order</span>
                <span v-else>PAY ${{currentTicket.price | ticketPrice}}</span>
              </Button>
            </div>
          </div>
          <div :class="['payment-option', paymentWay == 2 && 'selected']">
            <div class="payment-option__header" @click="handleSelectPaymentOption(2)">
              <div class="payment-option__left">
                <div class="payment-option__radio"></div>
                <img :src="static_img_url + 'pic/paypal-icon.png?v=' + $store.state.imgVersion" class="paypal-logo" />
              </div>
              <Button type="primary" :loading="buttonLoading" @click.stop="submitEn" v-if="paymentWay == 2">
                <span v-if="buttonLoading">Generating Order</span>
                <span v-else>PAY ${{currentTicket.price | ticketPrice}}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="payShow" width="530" class="login-model" :mask-closable="false" :footer-hide="true" :transfer="false" @on-visible-change="handleListenOrder">
      <div class="container-wrapper">
        <img :src="static_img_url + 'pic/modal-bg.png?v=' + $store.state.imgVersion" class="model-bg" />
        <div class="container-content">
          <div class="container-top">
            <div class="container-title reset-form-title">{{'支付订单-微信支付' | dealLanguage('WeChat Pay')}}</div>
            <div class="preview-pic">
              <img :src="payCodePath" class="code-img" />
              <div class="p0">{{'支付金额：' | dealLanguage('Amount')}}<span>￥{{currentTicket.price | ticketPrice}}</span></div>
              <div class="p1">
                <img :src="static_img_url + 'pic/wechat-icon.png?v=' + $store.state.imgVersion" />
                <span>{{'请使用微信扫码支付' | dealLanguage('Please use WeChat to scan the QR code to pay')}}</span>
              </div>
              <div class="p2">
                {{'支付过程中，请勿关闭此窗口' | dealLanguage('Please do not close this window during the payment process.')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import PageHeader from '@/components/pc/pageHeader.vue'
import Captcha from '@/components/common/captcha'
import TopTip from './topTip'
import { Agetmeta } from '@/service/app'
import { vbefGenOrder, orderStatus } from '@/service/vbef'
import { searchEntity } from 'js/searchEntity'
import buildTree from 'js/buildTree'
import QRCode from 'qrcode'
import { loginCommon } from '@/assets/js/login'
import { signUpMixins } from '@/assets/js/signUpMixins'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('预注册', 'Pre-registration'),
    }
  },
  inject: ['login'],
  mixins: [searchEntity, loginCommon, signUpMixins],
  components: {
    PageHeader,
    TopTip,
    Captcha,
  },
  created() {
    this.Agetmeta()
    this.getTicketList()
  },
  mounted() {
    // if (!this.user_key) {
    //   this.login(this.ininUserInfo)
    // } else {
    //   this.ininUserInfo()
    // }
  },
  beforeDestroy() {
    clearInterval(this.orderInv)
  },
  data() {
    return {
      buttonLoading: false,
      companyNatureTags: [],
      companyNatureTree: [],
      compNTother: '',
      currentForm: {
        name: '',
        compName: '',
        entityId: 0,
        department: '',
        title: '',
        email: '',
        addressId: '',
        companyProfile: '',
        companyprofileother: '',
        concurrent2: [],
        mobile: '',
        mobileAreaCode: '86',
      },
      payCodePath: '',
      payShow: false,
      currentTicket: {},
      orderInv: 0,
      payOrderId: '',
      currentPartnerId: 0,
      currentPartner: {},
    }
  },
  methods: {
    async Agetmeta() {
      let res = await Agetmeta({
        metaNameList: ['addressDtoList'],
      })
      if (res.code != 0) return

      this.$set(
        this.$data,
        'addressDtoList',
        res.data.addressDtoList.filter((a) => a.gpid != 2287)
      )
      const list =
        this.language == 'zh'
          ? res.data.addressDtoList
          : res.data.addressDtoList.filter((a) => a.gpid != 2287)
      const list2 = list.map((item) => {
        item.label = filter.dealLanguage(item.name, item.enName)
        item.value = item.id
        return item
      })
      this.addressDtos = buildTree(list2)

      // this.$set(this.$data, 'companyNatureTags', res.data.companyNatureTags)
      // res.data.companyNatureTags.forEach((tag) => {
      //   tag.label = filter.dealLanguage(tag.name, tag.enName)
      // })
      // const tree = buildTree(res.data.companyNatureTags)
      // this.companyNatureTree = [...tree]
      // this.handleChangeNT(this.currentForm.companyNatureId, 1)
    },
    handleChangeAddress(value, selectedData) {
      this.currentForm.addressId = value.length ? value[value.length - 1] + '' : ''
    },
    handleChangeCompanyProfile(value) {
      this.companyprofileother =
        value.indexOf('其他') > -1 || value.indexOf('Other') > -1 || value.indexOf('other') > -1
    },
    handleSeletTicket(value) {
      let item = this.ticketList.find((a) => a.id === value)
      this.currentTicket = { ...item }
    },
    submit() {
      if (this.buttonLoading) return
      // if (!this.user_key) {
      //   this.login(this.ininUserInfo)
      //   return
      // }
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true

          let { activityTicketId, ...params } = this.currentForm

          let ticketParamsStr = JSON.stringify(params)
          let pay_type = this.currentTicket.type == 1 ? 0 : 3
          let order = await vbefGenOrder({
            activityTicketId: activityTicketId,
            checkFormJson: ticketParamsStr,
            loginPlatform: 8,
            payType: pay_type,
          })
          this.buttonLoading = false
          if (order.code == 0) {
            if (order.data.payType == 0) {
              this.$Message.success(
                this.language == 'zh' ? '报名成功！' : 'Registration successful!'
              )
              this.$router.push({
                name: 'ticketDetail',
                params: { id: order.data.activityTicketUserRelationId },
              })
              return
            }
            QRCode.toDataURL(order.data.wxPayMpOrderNativeCodeUrl, {
              margin: 1,
              height: 320,
              width: 320,
            }).then((url) => {
              this.payOrderId = order.data.activityOrderId
              this.payShow = true
              this.payCodePath = url
            })
          } else {
            this.$Message.error(order.msg)
          }
        } else {
          this.$Message.error('请完善表单后提交')
        }
      })
    },
    async orderStatus(orderId) {
      let res = await orderStatus({
        id: this.payOrderId,
      })
      if (res.code == 0) {
        if (res.data.status == 2) {
          this.$Message.success(this.language == 'zh' ? '购买成功！' : 'Purchase successful!')
          clearInterval(this.orderInv)
          this.$router.push({
            name: 'ticketDetail',
            params: { id: res.data.activityTicketUserRelationId },
          })
        }
      }
    },
    handleListenOrder(value) {
      if (value) {
        this.orderInv = setInterval(() => {
          this.orderStatus()
        }, 1000)
      } else {
        clearInterval(this.orderInv)
      }
    },
  },
  watch: {
    companyprofileother() {
      this.currentForm.companyprofileother = ''
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-pc.styl'
@import '~styles/form-view.styl'
@import '~styles/ticket-item.styl'
@import '~styles/login.styl'
@import '~styles/sign-up-pc.styl'
</style>
